import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";
function TableComponent({ title, data, header, itemsPerPage }) {
  const [currentPage, setCurrentPage] = useState(0);
  const backUrl = Config.backOffice.url;
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const api = Config.backOffice.apiName;
  const offset = currentPage * itemsPerPage;
  const paginatedData = data.slice(offset, offset + itemsPerPage);

  return (
    <div className="table-responsive" style={{ fontFamily: "sans-serif" }}>
      <table className="table">
        <thead>
          <tr>
            {title?.can_edit == false &&
            title?.can_show == false &&
            title?.can_destroy == false ? (
              <th></th>
            ) : (
              <th style={{ cursor: "default" }} key="Action" className="text">
                Action
              </th>
            )}
            {header.map((column, index) => (
              <th
                key={index}
                style={{
                  textWrap: "pretty",
                  paddingLeft: "8px",
                  textalign: "center",
                  verticalalign: "middle",
                }}
              >
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody style={{ whiteSpace: "nowrap" }}>
          {paginatedData.length > 0 ? (
            <>
              {paginatedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <ul className="list-unstyled hstack gap-1 mb-0">
                      {title?.can_show ? (
                        <li
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View"
                        >
                          <Link
                            className="btn btn-sm btn-soft-primary"
                            id={`viewtooltip-${rowIndex}`}
                            to={`${backUrl}/souscriptions/${row.id}`}
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_edit ? (
                        <li title="Editer">
                          <Link
                            className="btn btn-sm btn-soft-info"
                            id={`edittooltip-${rowIndex}`}
                            to={`${backUrl}/souscriptions/${row.id}/edit`}
                          >
                            <i className="mdi mdi-pencil-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_destroy ? (
                        <li title="Supprimer">
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/souscriptions/${row.id}`}
                          />
                        </li>
                      ) : null}
                    </ul>
                  </td>
                  <td>{row.partenaire_id}</td>
                  <td>{row.statuts_souscription_id}</td>
                  <td>{row.natures_investissement_id}</td>
                  <td>{row.date_souscription}</td>
                  <td>{row.pme_id}</td>
                  <td>{row.nb_actions_souscrites}</td>
                  <td style={{ textAlign: "center" }}>
                    {row.valeur_action.toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {row.montant_souscription.toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {row.montant_reduction_impot.toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={header.length} style={{ textAlign: "center" }}>
                Aucune donnée à afficher
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"<<"}
        breakLabel={"..."}
        nextLabel={">>"}
        pageCount={Math.ceil(data.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageChange}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </div>
  );
}

export default TableComponent;
